import { createSlice } from "@reduxjs/toolkit";

const Productsclice = createSlice({
  name: "product",
  initialState: {
    productloading: false,
    insertdata: null,
    producterror: null,

    getproductloading: false,
    productdata: null,
    getproducterror: null,

    getcategoryloading: false,
    categorydata: null,
    getcategoryerror: null,

    getcompaniesloading: false,
    companiesdata: null,
    getcompanieserror: null,

    editproductloading: false,
    editproductdata: null,
    editproducterror: null,

    createBrandloading: false,
    createBranddata: null,
    createBranderror: null, 

    updateBrandloading: false,
    updateBranddata: null,
    updateBranderror: null,   

    getbrandloading: false,
    branddata: null,
    getbranderror: null,  

    deleteProductloading: false,
    deleteProductdata: null,
    deleteProducterror: null, 

    deleteBrandloading: false,
    deleteBranddata: null,
    deleteBranderror: null,   
  },
  reducers: {
    insertProductRequest: (state) => {
      state.productloading = true;
      state.producterror = null;
    },
    insertProductSuccess: (state, action) => {
      state.productloading = false;
      state.insertdata = action.payload;
    },
    insertProductFailure: (state, action) => {
      state.productloading = false;
      state.producterror = action.payload;
    },
    getProductRequest: (state) => {
      state.getproductloading = true;
      state.getproducterror = null;
    },
    getProductSuccess: (state, action) => {
      state.getproductloading = false;
      state.productdata = action.payload;
    },
    getProductFailure: (state, action) => {
      state.getproductloading = false;
      state.getproducterror = action.payload;
    },
    getcategoryRequest: (state) => {
      state.getcategoryloading = true;
      state.getcategoryerror = null;
    },
    getcategorySuccess: (state, action) => {
      state.getcategoryloading = false;
      state.categorydata = action.payload;
    },
    getcategoryFailure: (state, action) => {
      state.getcategoryloading = false;
      state.getcategoryerror = action.payload;
    },
    getcompaniesRequest: (state) => {
      state.getcompaniesloading = true;
      state.getcompanieserror = null;
    },
    getcompaniesSuccess: (state, action) => {
      state.getcompaniesloading = false;
      state.companiesdata = action.payload;
    },
    getcompaniesFailure: (state, action) => {
      state.getcompaniesloading = false;
      state.getcompanieserror = action.payload;
    },
    editProductRequest: (state) => {
      state.editproductloading = true;
      state.editproducterror = null;
    },
    editProductSuccess: (state, action) => {
      state.editproductloading = false;
      state.editproductdata = action.payload;
    },
    editProductFailure: (state, action) => {
      state.editproductloading = false;
      state.editproducterror = action.payload;
    },
    deleteProductRequest: (state) => {
      state.deleteProductloading = true;
      state.deleteProducterror = null;
    },
    deleteProductSuccess: (state, action) => {
      state.deleteProductloading = false;
      state.deleteProductdata = action.payload;
    },
    deleteProductFailure: (state, action) => {
      state.deleteProductloading = false;
      state.deleteProducterror = action.payload;
    },  
    createBrandRequest: (state) => {
      state.createBrandloading = true;
      state.createBranderror = null;
    },
    createBrandSuccess: (state, action) => {
      state.createBrandloading = false;
      state.createBranddata = action.payload;
    },
    createBrandFailure: (state, action) => {
      state.createBrandloading = false;
      state.createBranderror = action.payload;
    },
    updateBrandRequest: (state) => {
      state.updateBrandloading = true;
      state.updateBranderror = null;
    },
    updateBrandSuccess: (state, action) => {
      state.updateBrandloading = false;
      state.updateBranddata = action.payload;
    },
    updateBrandFailure: (state, action) => {
      state.updateBrandloading = false;
      state.updateBranderror = action.payload;
    },
    getBrandRequest: (state) => {
      state.getbrandloading = true;
      state.getbranderror = null;
    },
    getBrandSuccess: (state, action) => {
      state.getbrandloading = false;
      state.branddata = action.payload;
    },
    getBrandFailure: (state, action) => {
      state.getbrandloading = false;
      state.getbranderror = action.payload;
    },
    deleteBrandRequest: (state) => {
      state.deleteBrandloading = true;
      state.deleteBranderror = null;
    },
    deleteBrandSuccess: (state, action) => {
      state.deleteBrandloading = false;
      state.deleteBranddata = action.payload;
    },
    deleteBrandFailure: (state, action) => {
      state.deleteBrandloading = false;
      state.deleteBranderror = action.payload;
    },  
  },
});

export const {
  insertProductRequest,
  insertProductSuccess,
  insertProductFailure,
  getProductRequest,
  getProductSuccess,
  getProductFailure,
  getcategoryRequest,
  getcategorySuccess,
  getcategoryFailure,
  getcompaniesRequest,
  getcompaniesSuccess,
  getcompaniesFailure,
  editProductRequest,
  editProductSuccess,
  editProductFailure,
  createBrandRequest,
  createBrandSuccess,
  createBrandFailure,
  updateBrandRequest,
  updateBrandSuccess,
  updateBrandFailure,
  getBrandRequest,
  getBrandSuccess,
  getBrandFailure,
  deleteBrandRequest,
  deleteBrandSuccess,
  deleteBrandFailure,
  deleteProductRequest,
  deleteProductSuccess,
  deleteProductFailure,   
  } = Productsclice.actions;

export default Productsclice.reducer;
